import React, { useState, useEffect, useRef } from 'react';
import { useCrewStore, makeDelivery }           from '../../../store/crewStore';
import { showToast }                            from '../../shared/Toast';

interface Props { crewId: string; onClose: () => void; }

const AddDeliveryModal: React.FC<Props> = ({ crewId, onClose }) => {
  const updateCrew  = useCrewStore(s => s.updateCrew);
  const [address, setAddress] = useState('');
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => { setTimeout(() => ref.current?.focus(), 340); }, []);

  const save = () => {
    if (!address.trim()) { showToast('Please enter an address'); return; }
    updateCrew(crewId, c => ({
      ...c,
      deliveries: [...(c.deliveries || []), makeDelivery(address.trim())],
    }));
    showToast('Address added!');
    onClose();
  };

  return (
    <div className="modal-overlay active" onClick={onClose}>
      <div className="modal open" style={{display:'block'}} onClick={e => e.stopPropagation()}>
        <div className="modal-handle" />
        <div className="modal-title">Add Delivery Address</div>
        <div className="form-group">
          <label className="form-label">Address</label>
          <textarea
            ref={ref}
            className="form-textarea"
            placeholder={"Enter full delivery address…\ne.g. 42 Church Street, Birmingham, B3 2AP"}
            rows={4}
            value={address}
            onChange={e => setAddress(e.target.value)}
          />
        </div>
        <button className="btn-primary" onClick={save}>Add Address</button>
        <button className="btn-secondary" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default AddDeliveryModal;
